// 카테고리별 SEO 정보를 저장하는 파일입니다
export const categories = {
    animals: {
      name: "동물",
      title: "동물 플래시카드 - 50가지 동물 학습 | Baby Flashcards",
      description: "아이들을 위한 50가지 동물 플래시카드로 재미있게 동물 이름을 배워보세요. 한국어와 영어 발음을 함께 제공합니다.",
      keywords: "동물 플래시카드, 유아 동물 학습, 아기 동물카드, 동물 이름 배우기",
      image: "/images/animals-thumbnail.jpg",
      itemCount: 50
    },
    fruits: {
      name: "과일",
      title: "과일 플래시카드 - 50가지 과일 학습 | Baby Flashcards", 
      description: "신선한 50가지 과일 플래시카드로 아이들이 과일 이름을 재미있게 배울 수 있습니다. 한국어와 영어 학습을 동시에!",
      keywords: "과일 플래시카드, 유아 과일 학습, 아기 과일카드, 과일 이름 배우기",
      image: "/images/fruits-thumbnail.jpg", 
      itemCount: 50
    },
    objects: {
      name: "사물",
      title: "사물 플래시카드 - 50가지 생활용품 학습 | Baby Flashcards",
      description: "일상생활에서 볼 수 있는 50가지 사물 플래시카드로 아이들의 어휘력을 늘려보세요.",
      keywords: "사물 플래시카드, 유아 사물 학습, 생활용품 카드, 사물 이름 배우기",
      image: "/images/objects-thumbnail.jpg",
      itemCount: 50
    },
    transportation: {
      name: "교통수단", 
      title: "교통수단 플래시카드 - 50가지 탈것 학습 | Baby Flashcards",
      description: "자동차, 기차, 비행기 등 50가지 교통수단 플래시카드로 아이들이 탈것에 대해 배워보세요.",
      keywords: "교통수단 플래시카드, 유아 교통수단 학습, 탈것 카드, 교통수단 이름 배우기", 
      image: "/images/transportation-thumbnail.jpg",
      itemCount: 50
    },
    clothing: {
      name: "의류 및 액세서리",
      title: "의류 플래시카드 - 60가지 옷과 액세서리 학습 | Baby Flashcards",
      description: "옷, 신발, 액세서리 등 60가지 의류 플래시카드로 아이들이 패션에 대해 배워보세요.",
      keywords: "의류 플래시카드, 유아 의류 학습, 옷 카드, 액세서리 배우기",
      image: "/images/clothing-thumbnail.jpg", 
      itemCount: 60
    }
  };